// reducers/connect/save.js

export function connectSourcesSaveHasErrored(state = false, action) {
  switch (action.type) {
    case 'CONNECT_SOURCES_SAVE_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function connectSourcesSaveIsLoading(state = false, action) {
  switch (action.type) {
    case 'CONNECT_SOURCES_SAVE_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function connectSourcesSave(state = {}, action) {
  switch(action.type) {
    case 'CONNECT_SOURCES_SAVE_FETCH_DATA_SUCCESS':
      return action.obj;
    default:
      return state;
  }
}